import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { Language } from '@wizeoo/akm-message-lib';
import { Observable } from 'rxjs';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { ViewData } from '../../model/view.data';
import { Model } from '../../model/model';

@entity('wizeoo.allkey.locale.message.Language', 'BU')
export class LanguageVO implements IVo {
  /**
   * Le VO source provenant du back
   */
  private _source: Language;

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }

  constructor(model: Model, pSource?: Language) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new Language();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
  }

  public set source(language: Language) {
    this._source = language;
  }

  public get source(): Language {
    return this._source;
  }

  public set uid(uid: string) {
    this._source.uid = uid;
  }

  public get uid(): string {
    return this._source.uid;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  public get domain(): string {
    return this._source.domain;
  }
  public set domain(value: string) {
    this._source.domain = value;
  }

  @field('string')
  public set code(code: string) {
    // lower case pour l'utilisation dans moment
    this._source.code = code ? code.toLowerCase() : code;
  }

  public get code(): string {
    return this._source.code;
  }

  @field('string')
  public set label(label: string) {
    this._source.label = label;
  }

  public get label(): string {
    return this._source.label;
  }

  @field('string')
  public set alphabet(alphabet: string) {
    this._source.alphabet = alphabet;
  }

  public get alphabet(): string {
    return this._source.alphabet;
  }

  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }

  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  @field('boolean')
  public get deprecated(): boolean {
    return this._source.deprecated;
  }
  public set deprecated(deprecated: boolean) {
    this._source.deprecated = deprecated;
  }

  @field('boolean')
  public get deleted(): boolean {
    return this._source.deleted;
  }
  public set deleted(deleted: boolean) {
    this._source.deleted = deleted;
  }

  @field('string')
  public get icon(): string {
    return this._source.icon;
  }

  public set icon(pValue: string) {
    this._source.icon = pValue;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /**
   * accesseur pour recyclage des renderer de country (code / trsLabel)
   */
  public get trsLabel(): string {
    return this.label;
  }

  /**
   * l'objet existe en BDD (id)
   */
  public get exist(): boolean {
    return this.id > 0;
  }

  /** retourne l'icone si existe, sinon le média par défaut */
  public get iconOrDie(): Observable<string> {
    return AttachmentService.getInstance().iconOrDie(this.icon, ViewData.wildcardDomainLiteral, ViewData.wildcardDomainLiteral, ViewData.wildcardMainVision);
  }
}
